/** User-facing payment / refund labels (matches backend userPaymentSerializer). */

const PAYMENT_TYPE_LABELS = {
  Main: 'Main plan',
  AddOn: 'Add-on',
  addon: 'Add-on',
  contract_cycle: 'Contract billing',
  one_time: 'One-time',
  plan_selection: 'Plan selection',
};

export function getPaymentTypeLabel(type) {
  if (type == null || type === '') return null;
  const key = String(type).trim();
  return PAYMENT_TYPE_LABELS[key] || key.replace(/_/g, ' ');
}

export function getPaymentRefundInfo(payment) {
  const refund = payment?.refund;
  if (!refund) {
    return {
      hasRefund: payment?.status === 'refunded',
      label: payment?.status === 'refunded' ? 'Refunded' : null,
      isMandateAuthRefund: false,
      refundId: null,
      refundedAt: null,
      amount: null,
    };
  }

  return {
    hasRefund: refund.status === 'completed' || payment?.status === 'refunded',
    label: refund.label || (refund.isMandateAuthRefund ? 'Verification charge refunded' : 'Refunded'),
    isMandateAuthRefund: Boolean(refund.isMandateAuthRefund),
    refundId: refund.refundId || null,
    refundedAt: refund.refundedAt || null,
    amount: refund.amount ?? null,
  };
}

export function getPaymentStatusLabel(payment) {
  const refundInfo = getPaymentRefundInfo(payment);
  if (refundInfo.hasRefund && refundInfo.label) {
    return refundInfo.label;
  }
  const status = String(payment?.status || '').trim();
  if (!status) return '—';
  return status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, ' ');
}

export function paymentStatusChipColors(payment) {
  const refundInfo = getPaymentRefundInfo(payment);
  if (refundInfo.hasRefund) {
    return refundInfo.isMandateAuthRefund
      ? { bg: '#ecfdf5', color: '#047857' }
      : { bg: '#fef2f2', color: '#b91c1c' };
  }
  const status = String(payment?.status || '').toLowerCase();
  if (status === 'captured') return { bg: '#ecfdf5', color: '#047857' };
  if (status === 'failed') return { bg: '#fef2f2', color: '#b91c1c' };
  if (status === 'pending' || status === 'created') return { bg: '#fffbeb', color: '#b45309' };
  return { bg: '#f1f5f9', color: '#475569' };
}
